import axios from 'axios';
import { DateTime } from 'luxon';

import { parseError, request } from '../../helpers/requests';

const withDateRangeParams = (params = {}) => {
  const { startTime, endTime } = params;
  const apiParams = { ...params };
  if (startTime != null && endTime != null) {
    apiParams.startDate = DateTime.fromMillis(startTime).toISODate();
    apiParams.endDate = DateTime.fromMillis(endTime).toISODate();
  }

  return apiParams;
};

export default {
  get: (params) => request({
    call: axios.get('/analytics', { params: withDateRangeParams(params) }),
    errMsg: parseError('Could not get analytics data'),
    hideSuccessToast: true,
  }),
  create: (payload) => request({
    call: axios.post('/analytics', payload),
    errMsg: 'Could not create analytics report',
  }),
  update: (id, payload) => request({
    call: axios.put(`/analytics/${id}`, payload),
    errMsg: 'Could not update analytics report',
  }),
  delete: (id) => request({
    call: axios.delete(`/analytics/${id}`),
    errMsg: 'Could not delete analytics reports',
  }),
  getSaved: (analyticsType) => request({
    call: axios.get('/analytics/saved', { params: { analyticsType } }),
    errMsg: 'Could not get saved analytics reports',
    hideSuccessToast: true,
  }),
};
